module.exports = __webpack_public_path__ + "assets/df560c4d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/loader/loading.gif
// module id = 209
// module chunks = 0